<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData" />
        </template>
        <template slot="table-body">
            <rsa-paziente-sospensioni-adi-list-component ref="cmpSospensioniAdi" :idAccettazione="idAccettazione" :jsonDataAccettazione="jsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteSospensioniAdiListComponent from "../components/RsaPazienteSospensioneAdiListComponent.vue";

export default {
    name: "RsaPazienteSospensioniAdiPage",

    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteSospensioniAdiListComponent,
    },

    data() {
        return {
            idAccettazione: null,
            pathResource: null,
            pathResourceAccettazione: "/rsaaccettazioni",
            linkback: "/rsagestioneassistiti",
            showModalLoading: false,

            jsonData: {
                accettazioneAnagrafica: {},
                accettazionePrestazioni: {},
                accettazioneStati: [],
                accettazioneStruttura: {},
                accettazionePresidio: {},
            },
        };
    },

    mounted() {
        this.idAccettazione = this.$route.query.idAccettazione;
        this.loadAccettazione();
    },

    methods: {
        loadAccettazione() {
            let me = this;

            me.showModalLoading = true;

            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;

            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },

        onBeforeLoadData() {
            this.showModalLoading = true;
        },

        onAfterLoadData() {
            this.showModalLoading = false;
        },
    },
};
</script>
